export default {
    default: {
        fetchModelsPeriod: 30000, // définit le temps en ms entre chaque fetch
    },
    listModels: {
        logUserActions:{
            url: 'log-user-action/',
            verboseName: 'Log of user actions',
            fetch: false,
            scoped: true,
        },
        alarms: {
            url: 'alarm/',
            fetch: true,
            scoped: true,
            filter: {active: true},
        },
        alerts: {
            url: 'alert/',
            fetch: true,
            scoped: true,
            filter: {archived: false, acquited: false},
        },
        applications: {
            url: 'application/',
            fetch: false,
            scoped: true,
        },

            // l'organisation est le model qui scope les autres, on le fetch qu'une fois connecter (voir app.vue) afin d'etre sure qu'il soit fetché avant les autres
        organizations: {
            url: 'organization/',
            fetch: false,
        },
        instances: {
            url: 'instance/',
            fetch: false,
            scoped: true,
        },
        modelisations: {
            url: 'modelisation/',
            fetch: false,
            scoped: true,
        },
        deploymentRequests: {
            url: 'deployment-request/',
            fetch: false,
            scoped: true,
        },
        modificationRequests: {
            url: 'modification-request/',
            fetch: false,
            scoped: true,
        },
        organizationData: {
            url: 'organization-data/',
            fetch: true,
            scoped: true
        },
        importRequests: {
            url: 'import-request/',
            fetch: false,
        },
        applicationsCount: {
            url: 'application/',
            fetch: true,
            stats: true,
            filter: {archived: false}
        },

    },
};



// WEBPACK FOOTER //
// ./src/store/meta.js